// PrimeNG theme preset
//
// NOTE: PrimeNG's styled theming (@primeuix/themes) is JS-based, so the
// preset must be defined in TypeScript rather than SCSS.
//
// Used by app.config.ts via providePrimeNG({ theme: { preset: appPreset } }).

import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import type { ThemeType } from 'primeng/config';

// Override default theme colors

// branding blue (Blueprint)
const appPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E7F1FB',
      100: '#B3D4F4',
      200: '#8EBFEE',
      300: '#5BA2E6',
      400: '#3B90E1',
      500: '#0A74DA',
      600: '#096AC6',
      700: '#07529B',
      800: '#064078',
      900: '#04315C',
      950: '#172554',
    },
    list: {
      option: {
        padding: '0.25rem 0.75rem',
      },
      optionGroup: {
        padding: '0.25rem 0.75rem',
      },
    },
  },
});

// Full PrimeNG theme config — passed straight to providePrimeNG({ theme }).
export const appTheme: ThemeType = {
  preset: appPreset,
  options: {
    darkModeSelector: false,
    // Wrap PrimeNG's component CSS in a named cascade layer. Layered styles
    // always lose to unlayered styles, so our own .p-card overrides in the
    // app stylesheets win without needing !important.
    cssLayer: {
      name: 'primeng',
      order: 'primeng',
    },
  },
};
